import i18n from '@/localisation/i18n';
import { motion } from 'framer-motion';
import { isEmail } from 'validator';
import { useState } from 'react';
import clsx from 'clsx';
import { Appear } from '@/UI/animations/Appear';
import useToastStore from '@/store/toast';

export const Start = ({ onSubmit }: { onSubmit: (email: string) => void }) => {
  const [email, setEmail] = useState('');
  const [forceDisable, setForceDisable] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const addToast = useToastStore(state => state.addToast);

  const handleSubmit = () => {
    const isCorrectEmail = isEmail(email);

    if (isCorrectEmail) {
      onSubmit(email);
      setForceDisable(true);

      addToast(i18n.t('message.check.code'));
    } else {
      setEmailError(true);
    }
  };

  return (
    <div className="flex h-full w-full flex-col justify-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
      >
        <h1 className="md:text-4md mb-6 text-2xl font-bold">
          {i18n.t('welcome')}
        </h1>
        <h3 className="mb-10 text-base md:text-lg">
          {i18n.t('welcome.subtitle')}
        </h3>
        <div className="mb-9">
          <input
            value={email}
            type="text"
            className={clsx(
              'input input-bordered w-full gap-2 md:h-16 md:text-lg',
              emailError && 'input-error'
            )}
            placeholder="Email"
            onChange={e => {
              setEmail(e.target.value);
              setForceDisable(false);
              setEmailError(false);
            }}
          />
          <Appear isVisible={emailError}>
            <div className="label">
              <span className="label-text-alt text-error">
                {i18n.t('check.email')}
              </span>
            </div>
          </Appear>
        </div>
        <button
          disabled={!email || forceDisable}
          className="custom-btn btn btn-primary w-full md:h-16"
          onClick={handleSubmit}
        >
          {i18n.t('get.code')}
        </button>
      </motion.div>
    </div>
  );
};
